import { Location } from 'react-router';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDrawBudgetURL = (drawBudgetId: number, currentLocation: Location) => {
    let originPage = '';
    let originSection = '';
    const urlParts = currentLocation.pathname.split('/');
    if (urlParts.length > 1) {
        if (urlParts.length >= 3) {
            originPage = urlParts[2];
            originSection = urlParts[3];
        } else if (urlParts.length == 2) {
            originPage = urlParts[2];
        }
    }

    let budgetURL = `/draw/${drawBudgetId}`;
    if (originPage !== undefined && originPage !== null && originPage !== '') {
        budgetURL = budgetURL + `?originPage=${originPage}`;
        if (originSection !== undefined && originSection !== null && originSection !== '') {
            budgetURL = budgetURL + `&originSection=${originSection}`;
        }
    }
    return budgetURL;
};
